export default __webpack_public_path__ + "static/media/1829.17e2e123.png";